export default "__VITE_ASSET__DXPmYT9l__"